import React, { useState, useEffect } from "react";
import { Grid, Paper, Typography, Button, Box } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, journalize } from "@openimis/fe-core";
import { createODKUser, fetchAccreditationUsers, fetchQAUsers } from "../actions";
import OdkUsersList from "./OdkUsersList";
import { TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const styles = (theme) => ({
  page: theme.page,
  paper: theme.paper.paper,
  title: theme.paper.title,

  userLable: {
    padding: 4,
    margin: 4,
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    cursor: "pointer",
  },
});

function UsersPanel(props) {
  const { classes, submittingMutation, mutation, journalize, createODKUser, projectType, detailUuid, projectId } =
    props;

  const [user, setUser] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleAssignUser = () => {
    if (user) {
      createODKUser(selectedUser.id, projectType, detailUuid, "Assign User to Detail");
    }
  };

  // Auto Refresh the page
  const handleEvent = () => {
    window.location.reload();
  };

  // Monitor submittingMutation and mutation to trigger journalize
  useEffect(() => {
    if (submittingMutation && mutation) {
      journalize(mutation);
    }
    if (user) {
      if (projectType === "QA") {
        props.fetchQAUsers(user);
      } else {
        props.fetchAccreditationUsers(user);
      }
    }
  }, [submittingMutation, mutation, journalize, user, projectType]);

  return (
    <Paper className={classes.paper}>
      <Typography className={classes.title}>Add Odk User</Typography>
      <div className={classes.page}>
        <Grid container>
          <Grid item xs={6}>
            <TextField
              variant="outlined"
              placeholder="Search..."
              fullWidth
              value={
                selectedUser
                  ? selectedUser.username + " " + selectedUser.otherNames + " " + selectedUser.lastName
                  : user
              }
              onChange={(e) => setUser(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {(projectType === "QA" ? props.qualityAssuranceUsers : props.accreditationUsers)?.map((usr) => (
              <Typography key={usr.id} className={classes.userLable} onClick={() => setSelectedUser(usr)}>
                {usr.username + " "}
                {usr.otherNames + " "}
                {usr.lastName}
              </Typography>
            ))}
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="end">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleAssignUser();
              handleEvent();
            }}
            disabled={!selectedUser}
          >
            Add Odk User
          </Button>
        </Box>
        <OdkUsersList detailUuid={detailUuid} projectId={projectId} detailType={projectType} />
      </div>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  console.log("Redux State", state);
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    mutation: state.quality_assurance_and_accreditation.mutation, // Adjust if needed
    submittingMutation: state.quality_assurance_and_accreditation.submittingMutation,
    accreditationUsers: state.quality_assurance_and_accreditation.accreditationUsers,
    qualityAssuranceUsers: state.quality_assurance_and_accreditation.qualityAssuranceUsers, // ← Add this
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ journalize, createODKUser, fetchAccreditationUsers, fetchQAUsers }, dispatch);
};

export default withModulesManager(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(withTheme(withStyles(styles)(UsersPanel)))),
);
